import { render, staticRenderFns } from "./EquipmentAssignment.vue?vue&type=template&id=2216b98a&scoped=true"
import script from "./EquipmentAssignment.vue?vue&type=script&lang=js"
export * from "./EquipmentAssignment.vue?vue&type=script&lang=js"
import style0 from "./EquipmentAssignment.vue?vue&type=style&index=0&id=2216b98a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2216b98a",
  null
  
)

export default component.exports